<template>
  <!-- 国交省データ検索FAB: 右下固定 -->
  <div v-if="showFab" class="mlit-fab-container">
    <v-btn
      v-track="'mlit-search-fab'"
      class="mlit-fab"
      size="x-large"
      icon
      elevation="8"
      @click="openSearch"
    >
      <MiniTooltip text="国交省 × OH3 チャット" :offset-x="0" :offset-y="18">
        <span class="mlit-fab-text">国交省<br><small>× OH3</small></span>
      </MiniTooltip>
    </v-btn>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import MiniTooltip from '@/components/MiniTooltip.vue'

const WINDOW_ID = 'mlit-search-window'

export default {
  name: 'MlitSearchFab',
  components: { MiniTooltip },
  computed: {
    ...mapState([
      'isPrint',
      'isIframe'
    ]),
    showFab() {
      if (this.isPrint || this.isIframe) return false
      // スマホ時 & PC状態でない場合は非表示
      if (this.$store.state.isSmall500 && !this.$store.state.showPcMode) return false
      return true
    }
  },
  methods: {
    openSearch() {
      const app = this.$root || this.$store.state.oh3App || window.vueApp
      app?.usageTracker?.trackEvent('mlit-search-fab', 'click', 'open', { text: '国交省 × OH3 チャット' })

      this.$store.commit('setFloatingVisible', { id: WINDOW_ID, visible: true })
    }
  }
}
</script>

<style scoped>
.mlit-fab-container {
  position: fixed;
  bottom: 234px;
  right: 20px;
  z-index: 1002;
}

.mlit-fab {
  width: 64px !important;
  height: 64px !important;
  border-radius: var(--oh3-radius-full) !important;
  background: linear-gradient(135deg, rgb(21, 101, 192), rgb(30, 136, 229)) !important;
  color: white !important;
  box-shadow:
    0 6px 20px rgba(21, 101, 192, 0.45),
    0 3px 10px var(--oh3-color-overlay-20) !important;
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) !important;
}

.mlit-fab:hover {
  transform: scale(1.1) !important;
  box-shadow:
    0 8px 25px rgba(21, 101, 192, 0.55),
    0 4px 15px var(--oh3-color-overlay-30) !important;
}

.mlit-fab:active {
  transform: scale(0.95) !important;
}

.mlit-fab-text {
  font-size: var(--oh3-font-size-base);
  font-weight: 700;
  letter-spacing: 0.5px;
  line-height: 1.2;
  text-align: center;
}

.mlit-fab-text small {
  font-size: var(--oh3-font-size-xs);
  font-weight: 600;
  letter-spacing: 1px;
  opacity: 0.85;
}

/* モバイル対応 */
@media (max-width: 500px) {
  .mlit-fab-container {
    bottom: 210px;
    right: 16px;
  }

  .mlit-fab {
    width: 56px !important;
    height: 56px !important;
  }

  .mlit-fab-text {
    font-size: var(--oh3-font-size-sm);
  }
}

/* 印刷時は非表示 */
@media print {
  .mlit-fab-container {
    display: none !important;
  }
}
</style>
